
// See ChatBotFlowConstants in php
const flowActionTypes = Object.freeze({
    ACTION_MESSAGE: 1,
    ACTION_QUESTION: 2,
    ACTION_REQUEST_INFO: 3,
    ACTION_FAQ: 4,
    ACTION_CHAT: 5,
    ACTION_TICKET: 6,
    ACTION_LIBGUIDES: 7,
    ACTION_LIBCAL: 8,
    ACTION_WELCOME: 9,
    ACTION_LINK: 10,
    ACTION_LIBWIZARD: 11,
    ACTION_RATING: 12,
    ACTION_PARAMS: 13
});

/**
 * Special action ids.
 */
const flowActionIds = Object.freeze({
    ACTION_END: -1,
    ACTION_SKIP: -2,
    ACTION_NULL: -4, // a default for no action at all
    ACTION_TRANSFER: -5 // transfer to anothe flow
});

const flowActionIcons = Object.freeze({
    [flowActionTypes.ACTION_MESSAGE]: 'fa-commenting-o',
    [flowActionTypes.ACTION_QUESTION]: 'fa-question-circle-o',
    [flowActionTypes.ACTION_REQUEST_INFO]: 'fa-address-book',
    [flowActionTypes.ACTION_FAQ]: 'fa-search',
    [flowActionTypes.ACTION_CHAT]: 'fa-comments-o',
    [flowActionTypes.ACTION_TICKET]: 'fa-ticket',
    [flowActionTypes.ACTION_LIBGUIDES]: 'fa-search',
    [flowActionTypes.ACTION_LIBCAL]: 'fa-calendar',
    [flowActionTypes.ACTION_WELCOME]: 'fa-home',
    [flowActionIds.ACTION_END]: 'fa-home',
    [flowActionTypes.ACTION_LINK]: 'fa-link',
    [flowActionTypes.ACTION_LIBWIZARD]: 'fa-clipboard',
    [flowActionTypes.ACTION_RATING]: 'fa-star',
    [flowActionTypes.ACTION_PARAMS]: 'fa-map-signs'
});

const flowAlertTypes = Object.freeze({
    [flowActionTypes.ACTION_MESSAGE]: 'alert-info',
    [flowActionTypes.ACTION_QUESTION]: 'alert-info',
    [flowActionTypes.ACTION_REQUEST_INFO]: 'alert-success',
    [flowActionTypes.ACTION_FAQ]: 'alert-warning',
    [flowActionTypes.ACTION_CHAT]: 'alert-warning',
    [flowActionTypes.ACTION_TICKET]: 'alert-warning',
    [flowActionTypes.ACTION_LIBGUIDES]: 'alert-warning',
    [flowActionTypes.ACTION_LIBCAL]: 'alert-warning',
    [flowActionTypes.ACTION_WELCOME]: 'alert-info',
    [flowActionTypes.ACTION_LINK]: 'alert-warning',
    [flowActionTypes.ACTION_LIBWIZARD]: 'alert-warning',
    [flowActionTypes.ACTION_RATING]: 'alert-info',
    [flowActionTypes.ACTION_PARAMS]: 'alert-info'
});

const flowRuleTypes = Object.freeze({
    PRESET: 0,
    FREE: 1,
    PASSALONG: 2
});

const ruleMatchTypes = Object.freeze({
    MATCH_ANY: 1,
    MATCH_ALL: 2
});

const responseSpecialIds = Object.freeze({
    PAGE_BACK: -1,
    PAGE_FORWARD: -2,
    STAGE_BACK: -3
});

const contactInfoTypes = Object.freeze({
    INFO_NAME: 1,
    INFO_EMAIL: 2,
    INFO_ID: 4,
    INFO_NAME_EMAIL: 3, // Doing this like unix permissions so it can stay a Number
    INFO_NAME_ID: 5,
    INFO_EMAIL_ID: 6,
    INFO_NAME_EMAIL_ID: 7
});

// Request action stages
const requestStages = Object.freeze({
    NAME: 0,
    ID: 1,
    EMAIL: 2,
    EVALUATE: 3
});

const chatTypes = Object.freeze({
    SEND_OP: 1,
    SEND_DEPT: 2
});

// Search action stages
const searchStages = Object.freeze({
    PROMPT: 0,
    RESULT: 1,
    FAIL: 2,
    CHAINED: 3
});

const faqTypes = Object.freeze({
    FAQ_SINGLE: 1,
    FAQ_SEARCH: 2,
    FAQ_RESULTS: 3
});

const lgTypes = Object.freeze({
    GUIDE_SINGLE: 1,
    AZ_SINGLE: 2,
    GUIDE_SEARCH: 3,
    AZ_SEARCH: 4,
    LG_OTHER: 5
});

const lcTypes = Object.freeze({
    BOOKING_SPACE: 1,
    BOOKING_EQUIP: 2,
    BOOKING_APPT: 3,
    EVENT_SEARCH: 4,
    HOURS_TODAY: 5,
    HOURS_WEEK: 6
});

const bookingStages = Object.freeze({
    GROUP_PROMPT: 0,
    CAT_PROMPT: 2,
    CAT_USER_PROMPT: 3,
    USER_PROMPT: 4,
    DATE_PROMPT: 5,
    TIME_PROMPT: 6,
    FORM: 8,
    AUTHLINK: 9,
    FAIL: 99
});

const lzTypes = Object.freeze({
    LWZ_FORM: 1,
    LWZ_SURVEY: 2,
    LWZ_QUIZ: 4,
    LWZ_TUTORIAL: 8
});

// see QuestionBankConstants in php
const questionBankTypes = Object.freeze({
    TYPE_TEXT: 0,
    TYPE_CHOICE: 1
});

// Ticket action stages
const ticketStages = Object.freeze({
    PROMPT: 0,
    CONTACT: 1,
    QUESTION: 2,
    FORM: 3
});

const linkResponseTypes = Object.freeze({
    YES: 1,
    NO: 2
});

const searchResponseTypes = Object.freeze({
    RETRY: 3,
    UNRESOLVED: 1,
    RESOLVED: 2
});

const availabilityTypes = Object.freeze({
    AVAIL_ONLINE: 0,
    AVAIL_ALWAYS: 1,
    AVAIL_OFFLINE_ONLY: 2,
    AVAIL_COOP_ONLY: 3,
    AVAIL_CUSTOM_HOURS: 4
});

const ratingTypes = Object.freeze({
    CHAT_FORM: 0,
    NPS_SURVEY: 1
});

const paramTypes = Object.freeze({
    PARAM_CHAT_STATUS: 1,
    PARAM_OPEN_HOURS: 2,
    PARAM_LC_HOURS: 3
});

const paramResponseTypes = Object.freeze({
    PARAM_CHAT_STATUS_ONLINE: 1,
    PARAM_CHAT_STATUS_OFFLINE: 2,
    PARAM_HOURS_OPEN: 3,
    PARAM_HOURS_CLOSED: 4
});

const MAX_ACTIONS = 50;
const MAX_RULES = 30;

const actionResponseTypes = Object.freeze({
    ACTION_RESPONSE_SEARCH: 0,
    ACTION_RESPONSE_CLICK: 1,
    ACTION_RESPONSE_HELP_YES: 2,
    ACTION_RESPONSE_HELP_NO: 3,
    ACTION_RESPONSE_RESOLVED: 4,
    ACTION_RESPONSE_UNRESOLVED: 5
});

let flowActionLabels = {};
let matchTypeLabels = {};
let infoTypeLabels = {};
let chatTypeLabels = {};
let faqTypeLabels = {};
let lgTypeLabels = {};
let lcTypeLabels = {};
let lzTypeLabels = {};
let lzNonLocalTypeLabels = {};
let ratingTypeLabels = {};
let paramTypeLabels = {};
let paramRuleOptions = {};

const setLocalizedLabels = function({
    localflowActionLabels = {},
    localmatchTypeLabels = {},
    localinfoTypeLabels = {},
    localchatTypeLabels = {},
    localfaqTypeLabels = {},
    locallgTypeLabels = {},
    locallcTypeLabels = {},
    locallzTypeLabels = {},
    nonLocalLzTypeLabels = {},
    localRatingTypeLabels = {},
    localparamTypeLabels = {},
    localparamRuleOptions = {}
}) {
    flowActionLabels = localflowActionLabels;
    matchTypeLabels = localmatchTypeLabels;
    infoTypeLabels = localinfoTypeLabels;
    chatTypeLabels = localchatTypeLabels;
    faqTypeLabels = localfaqTypeLabels;
    lgTypeLabels = locallgTypeLabels;
    lcTypeLabels = locallcTypeLabels;
    lzTypeLabels = locallzTypeLabels;
    lzNonLocalTypeLabels = nonLocalLzTypeLabels;
    ratingTypeLabels = localRatingTypeLabels;
    paramTypeLabels = localparamTypeLabels;
    paramRuleOptions = localparamRuleOptions;
};

export {
    flowActionTypes,
    flowActionIcons,
    flowAlertTypes,
    flowActionIds,
    flowRuleTypes,
    ruleMatchTypes,
    responseSpecialIds,
    contactInfoTypes,
    requestStages,
    chatTypes,
    searchStages,
    faqTypes,
    lgTypes,
    lcTypes,
    bookingStages,
    lzTypes,
    questionBankTypes,
    ticketStages,
    linkResponseTypes,
    searchResponseTypes,
    availabilityTypes,
    ratingTypes,
    paramTypes,
    paramResponseTypes,
    flowActionLabels,
    matchTypeLabels,
    infoTypeLabels,
    chatTypeLabels,
    faqTypeLabels,
    lgTypeLabels,
    lcTypeLabels,
    lzTypeLabels,
    ratingTypeLabels,
    paramTypeLabels,
    paramRuleOptions,
    setLocalizedLabels,
    MAX_ACTIONS,
    MAX_RULES,
    actionResponseTypes,
    lzNonLocalTypeLabels
};
